








































































import { Component, Vue } from 'vue-property-decorator';
import RestcommProfiles from "@/consoleapi/api/restcomm/profiles";

@Component
export default class Accounts extends Vue {
    protected account = {};

    private name = null;

    private email = null;

    private password = null;


    private password_confirmation = null;

    getProfile(){
        const profiles = new RestcommProfiles();
        profiles.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        profiles.find(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)))
            .then(response => {
                console.log(response.data);
                this.account = response.data;
                this.name = response.data.friendly_name;
            })
            .catch(error => {
                console.log(error.response);
            });
    }

    updateProfile() {
        const profiles = new RestcommProfiles();
        if (this.password && this.password !== this.password_confirmation) {
            alert('パスワードを入力してください');
            return;
        }
        profiles.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        profiles.update(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.name, null, this.password)
            .then(response => {
                console.log(response.data);
                this.getProfile();
            }).catch(error => {
            alert(error.response.message);
        })
    }


    mounted() {
        this.getProfile();
    }
}
